import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { InvitationPreview } from "../components";
import { domain } from "../consts";
import { getCloudflareImageUrl } from "../utils/imageOptimization";

const InvitationPage = () => {
  const { rsvpId } = useParams();

  const uuidPattern =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const isSlug = uuidPattern.test(rsvpId);

  const [rsvp, setRsvp] = useState(null);

  useEffect(() => {
    if (rsvp) {
      if (rsvp.shareTitle) {
        document.title = rsvp.shareTitle;
      }
    }
  }, [rsvp]);

  useEffect(() => {
    const fetchRSVP = async () => {
      try {
        const rsvpResponse = await fetch(
          `${domain}/rsvp/${rsvpId}${!isSlug ? "?slug=true" : ""}`,

          {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        if (!rsvpResponse.ok) {
          throw new Error(`HTTP error! Status: ${rsvpResponse.status}`);
        }

        const rsvpData = await rsvpResponse.json();

        setRsvp(rsvpData);
      } catch (error) {
        console.error("Error fetching RSVP:", error);
        window.location.assign("/404");
      }
    };

    fetchRSVP();
  }, [rsvpId]);

  return (
    rsvp && (
      <>
        <Helmet>
          <title>{rsvp.shareTitle || "Pozivnica"}</title>
          <meta property="og:title" content={rsvp.shareTitle || "Pozivnica"} />
          <meta property="og:description" content="Uljepšajmo ovaj dan" />
          {rsvp.headerImage ? (
            <meta
              property="og:image"
              content={getCloudflareImageUrl(
                rsvp.headerImage,
                "format=auto,width=1200",
              )}
            />
          ) : rsvp.texture ? (
            <meta
              property="og:image"
              content={getCloudflareImageUrl(
                rsvp.texture,
                "format=auto,width=1200",
              )}
            />
          ) : null}
          <meta property="og:type" content="website" />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:site_name" content="Pozivnica" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={rsvp.shareTitle || "Pozivnica"} />
          <meta name="twitter:description" content="Uljepšajmo ovaj dan" />
          {rsvp.headerImage ? (
            <meta
              name="twitter:image"
              content={getCloudflareImageUrl(
                rsvp.headerImage,
                "format=auto,width=1200",
              )}
            />
          ) : rsvp.texture ? (
            <meta
              name="twitter:image"
              content={getCloudflareImageUrl(
                rsvp.texture,
                "format=auto,width=1200",
              )}
            />
          ) : null}
        </Helmet>
        <InvitationPreview rsvp={rsvp} />
      </>
    )
  );
};

export default InvitationPage;
